var _path, _path2, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDvpn(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.4316 1.5H2.43164V11.7413C2.43164 13.5685 2.69446 15.4042 3.56378 17.0113C5.00414 19.6742 7.8677 23.5 12.4316 23.5C16.9956 23.5 19.8591 19.6742 21.2995 17.0113C22.1688 15.4042 22.4316 13.5685 22.4316 11.7413V1.5Z",
    fill: "#142E51"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.93164 1H22.9316V11.7413C22.9316 13.6104 22.6639 15.5398 21.7393 17.2492C20.2895 19.9295 17.2991 24 12.4316 24C7.56423 24 4.57381 19.9295 3.124 17.2492C2.19936 15.5398 1.93164 13.6104 1.93164 11.7413V1ZM2.93164 2V11.7413C2.93164 13.5265 3.18956 15.2686 4.00357 16.7734C5.43446 19.4188 8.17118 23 12.4316 23C16.6921 23 19.4288 19.4188 20.8597 16.7734C21.6737 15.2686 21.9316 13.5265 21.9316 11.7413V2H2.93164Z",
    fill: "#3DB2E6"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.4316 4H5.43164V8.59599L16.4895 16.9195L15.5979 17.6598L5.43164 10.0836V10.7942C5.43164 12.5571 5.65871 14.3415 6.54574 15.8649C7.63234 17.731 9.54669 20 12.4316 20C15.3166 20 17.2309 17.7311 18.3175 15.8649C18.9372 14.8006 19.2348 13.6089 19.3579 12.3862L9.69238 5.09229H11.4253L19.4305 11.0118C19.4313 10.9392 19.4316 10.8667 19.4316 10.7942V4Z",
    fill: "#488FCC"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDvpn);
export default __webpack_public_path__ + "static/media/dvpn.cc1466497400ff985a5350218a1a5063.svg";
export { ForwardRef as ReactComponent };